import { useEffect } from 'react';
import { pageView } from '../tracking';

export const usePageView = () => {
    useEffect(() => {
        console.log('view!');
        pageView();
    }, []);
};
